import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { idsVisibles } from 'views/tickets/utils/conditionalQuestions'

/**
 * El `validate` del cuestionario llena `errors` desde el primer render, asi que
 * la pantalla abriria con todas las obligatorias en rojo sin que el usuario haya
 * intentado nada.
 *
 * Este watcher congela, en cada intento de envio, que preguntas estaban a la
 * vista: son las unicas cuyo error se muestra. Una hija que aparece despues del
 * intento arranca neutra, porque el usuario todavia no tuvo ocasion de
 * responderla.
 *
 * Devuelve un `Set` de claves canonicas, para consultar con `claveDeId(id)`.
 */
const PreguntasExigidasWatcher = ({ preguntas, onExigidasChange }) => {
    const { submitCount, values } = useFormikContext()

    useEffect(() => {
        // `resetForm` deja `submitCount` en 0: sin esto el Set sobrevive al
        // reset y el formulario reabre con los errores del intento anterior.
        if (submitCount === 0) {
            onExigidasChange(new Set())
            return
        }
        onExigidasChange(idsVisibles(preguntas || [], values))
        // `values` queda afuera a proposito: es una foto del momento del intento,
        // no un seguimiento de lo que el usuario responde despues. `preguntas` SI
        // va, porque el cuestionario puede llegar async despues de un envio, y sin
        // recalcular el Set quedaria vacio: el submit bloqueado por errores que no
        // se muestran en ningun lado.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitCount, preguntas])

    return null
}

export default PreguntasExigidasWatcher
